import React, { ReactNode } from 'react';

import classes from './OrderDetailsLayout.module.scss';
import { SwymoHeader } from '../../../../shared/components/header-components/SwymoHeader/SwymoHeader';
import { Footer } from '../Footer/Footer';

type OrderDetailsLayoutProps = {
  children: ReactNode;
};

const OrderDetailsLayout = ({ children }: OrderDetailsLayoutProps) => {
  return (
    <div className={classes.container}>
      <SwymoHeader />
      <div className={classes.content}>{children}</div>
      <div className={classes.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
};

export { OrderDetailsLayout };
